export default (): CreditCode => ({
  creditCodeValue: null
})
